import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../context/LangContext";
import { BOOK_PATH, HERO, STRINGS } from "../../data/content";

export default function Hero() {
  const { t } = useLang();
  return (
    <section className="hero" style={{ "--hero-bg": "url('/images/img_1.jpg')" }}>
      <div className="hero-inner">
        <p className="hero-slogan fade-in">{t(HERO.slogan)}</p>
        <h1 className="hero-headline fade-in d1">{t(HERO.headline)}</h1>
        <p className="hero-sub fade-in d2">{t(HERO.sub)}</p>
        <div className="fade-in d3">
          <Link to={BOOK_PATH} className="btn btn-inverse btn-large">
            {t(STRINGS.bookCallFree)}
          </Link>
        </div>
        <div className="hero-bullets fade-in d4">
          {HERO.bullets.map((b) => (
            <div className="hero-bullet" key={b.id}>
              <span className="check">✓</span>
              <span>{t(b)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
